module.exports = __webpack_public_path__ + "img/img_career_tit.6e9cd780.svg";